
/**
 * @export
 * @type VendorApprovalRule
 */
export type VendorApprovalRule = {
    /**
     * The unique identifier of the approval rule
     */
    ruleId: string;
    /**
     * The name of the approval rule
     */
    ruleName: string;
    /**
     * The ID of the vendor associated with the approval rule
     */
    vendorId: string;
    /**
     * The ID of the entitlement associated with the approval rule
     */
    entitlementId: string;
    /**
     * The name of the entitlement associated with the approval rule
     */
    entitlementName: string;
    /**
     * The description of the entitlement associated with the approval rule
     */
    entitlementDescription: string;
    entitlementStatus: VendorApprovalRuleEntitlementStatus;
}

export enum VendorApprovalRuleEntitlementStatus {
    ALLOW = 'ALLOW',
    DENY = 'DENY'
}